import axios from '../../axios';
import { toast } from 'react-toastify';
import { ADD_STYLE, DELETE_STYLE, GET_STYLE, UPDATE_STYLE, GET_ONE_STYLE } from '../types';

export const getStyle = (params) => async (dispatch) => {
  try {
    const res = await axios.get('/style/all', { params });

    if (res.data.code === 1) {
      dispatch({
        type: GET_STYLE,
        payload: {
          data: res.data.data || [],
          pagination: res.data.pagination || {},
          totalCount: res.data.totalCount || 0,
        },
      });
    }
  } catch (err) {
    if (err.response.data.errors[0].message) {
      toast.error(err.response.data.errors[0].message);
    }
    // console.error('Failed to get Style. Please try again. :', err);
  }
};

export const addStyle = (formData) => async (dispatch) => {
  try {
    const res = await axios.post('/style/add', formData);

    if (res.data.code === 1) {
      dispatch({ type: ADD_STYLE, payload: res.data.data });
      setTimeout(() => {
        toast.success('Style added successfully!');
      }, 1000);
    }
    if (res.data.code === 0) {
      setTimeout(() => {
        toast.error(res.data.message);
      }, 1000);
    }
  } catch (err) {
    if (err.response.status) {
      toast.error(err.response.data.message);
      return;
    }
    if (err.response.data)
      if (err.response && err.response.data && err.response.data.code === 1) {
        return;
      }
    const errorMessage = err.response?.data?.errors?.[0]?.message;
    toast.error(errorMessage || 'An error occurred. Please try again.');
    // if (err.response.data.errors[0].message) {
    //   toast.error(err.response.data.errors[0].message);
    // }
  }
};

export const updateStyle = (formData) => async (dispatch) => {
  try {
    const res = await axios.post(`/style/update`, formData);

    if (res.data.code === 1) {
      dispatch({ type: UPDATE_STYLE, payload: res.data.data });

      setTimeout(() => {
        toast.success('Style updated successfully!');
      }, 1000);
    }
  } catch (err) {
    if (err.response.data.errors[0].message) {
      toast.error(err.response.data.errors[0].message);
    }
    // toast.error('Failed to update Style. Please try again.');
  }
};

// Delete Style
export const deleteStyle = (id) => async (dispatch) => {
  try {
    if (!id) {
      toast.error('Please select any record');
      return false;
    }
    const res = await axios.post(`/style/delete/${id}`);
    if (res.data.code === 1) {
      dispatch({ type: DELETE_STYLE, payload: { id } });
      setTimeout(() => {
        toast.success('Style deleted successfully!');
      }, 1000);
    }
  } catch (err) {
    if (err.response.data.errors[0].message) {
      toast.error(err.response.data.errors[0].message);
    }
    // toast.error('Failed to delete Model. Please try again.');
  }
};

export const getSingleStyle = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`/style/${id}`);
    if (res.data.code === 1) {
      dispatch({ type: GET_ONE_STYLE, payload: res.data.data });
    }
  } catch (err) {
    console.error('Failed to get item by finish item. Please try again.');
    if (err.response.data.message) {
      toast.error(err.response.data.message);
    }
  }
};